module.exports = __webpack_public_path__ + "img/logo-dark.4a01f8de.png";